
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.805 1.359A2.666 2.666 0 012.75.5h3.488c.53 0 1.04.225 1.414.625l5.825 6.214c.376.4.586.943.586 1.508 0 .566-.21 1.109-.585 1.509L9.24 14.875c-.375.4-.884.625-1.414.625-.531 0-1.04-.225-1.415-.625L.586 8.661A2.208 2.208 0 010 7.153v-3.72c0-.778.29-1.524.805-2.074zm1.944.212c-.462 0-.906.197-1.234.546-.327.348-.51.822-.51 1.315v3.72c0 .282.104.553.291.752l5.826 6.213c.186.2.44.312.704.312a.964.964 0 00.704-.311l4.236-4.52a1.1 1.1 0 00.292-.75c0-.283-.105-.553-.291-.751L6.94 1.883a.965.965 0 00-.704-.312H2.749z","fill":"#333"}}),_c('path',{attrs:{"d":"M3.723 2.957c.189.2.295.473.295.757 0 .284-.106.557-.295.758a.973.973 0 01-.71.314.973.973 0 01-.71-.314 1.108 1.108 0 01-.294-.758c0-.284.106-.556.294-.757a.973.973 0 01.71-.314c.267 0 .522.113.71.314z","fill":"#333"}})])
          )
        }
      }
    